// import { View } from './view'
import { PageLayoutV2 } from '@shared/components/page-layout-v2'

export const PageLayout = PageLayoutV2
